import { Switch, Route } from "react-router-dom";
import Login from "./login";
import Dashboard from "./app";
import Appointment from "./appointments";
import Manage from "./manage";
import Reassign from "./reassign";
import Swap from "./swap";
import ScanQr from "./qr-reader/QrReader";
import WXWO from "./form/wxwo";
import NGAT from "./form/ngat";
import Duct from "./form/duct";
import NOC from "./form/noc";
import AIWO from "./form/aiwo";
import Washer from "./form/washer";

import SCE from "./form/sce";

import InspectionFormHub from "./inspection-form-hub";
import InspectionPage1 from "./form/state-forms/inspection/page-1";
import InspectionPage2 from "./form/state-forms/inspection/page-2";
import InspectionPage3 from "./form/state-forms/inspection/page-3";
import InspectionPage4 from "./form/state-forms/inspection/page-4";
import InspectionPage5 from "./form/state-forms/inspection/page-5";
import InspectionPage6 from "./form/state-forms/inspection/page-6";
import InspectionPage7 from "./form/state-forms/inspection/page-7";
import InspectionPage8 from "./form/state-forms/inspection/page-8";
import InspectionPage9 from "./form/state-forms/inspection/page-9";
import InspectionPage10 from "./form/state-forms/inspection/page-10";
import InspectionPage11 from "./form/state-forms/inspection/page-11";

import RAndRHub from "./repair-and-replaced-hub"
import RepairedAndReplacedPage1 from "./form/state-forms/repair-and-replace/page-1";
import RepairedAndReplacedPage2 from "./form/state-forms/repair-and-replace/page-2";

import CASInterim from "./form/state-forms/interim";

import ComplianceReportHub from "./compliance-report-hub";
import ComplianceReportPage1 from "./form/state-forms/compliance-report/page-1";
import ComplianceReportPage2 from "./form/state-forms/compliance-report/page-2";
import ComplianceReportPage3 from "./form/state-forms/compliance-report/page-3";

import DuctLeakageHub from "./duct-leakage-hub";
import DuctLeakagePage1 from "./form/state-forms/duct-leakage/page-1";
import DuctLeakagePage2 from "./form/state-forms/duct-leakage/page-2";
import DuctLeakagePage3 from "./form/state-forms/duct-leakage/page-3";

import ShellLeakageHub from "./shell-leakage-hub";
import ShellLeakagePage1 from "./form/state-forms/shell-leakage/page-1";
import ShellLeakagePage2 from "./form/state-forms/shell-leakage/page-2";
import ShellLeakagePage3 from "./form/state-forms/shell-leakage/page-3";
import ShellLeakagePage4 from "./form/state-forms/shell-leakage/page-4";

import NoticeOfSurvey from './form/state-forms/notice-of-survey';

import WindowAndDoor from './form/state-forms/window-and-door';

import InsulationCertifcate from './form/state-forms/insulation-certificate';

const Routes = () => {
  return (

    <Switch>
      <Route path="/form/shell-leakage/:version/1/:appointmentId"> 
        <ShellLeakagePage1  />
      </Route>
      <Route path="/form/shell-leakage/:version/2/:appointmentId"> 
        <ShellLeakagePage2  />
      </Route>
      <Route path="/form/shell-leakage/:version/3/:appointmentId"> 
        <ShellLeakagePage3 />
      </Route>
      <Route path="/form/shell-leakage/:version/4/:appointmentId"> 
        <ShellLeakagePage4 />
      </Route>
      <Route path="/form/shell-leakage/:appointmentId"> 
        <ShellLeakageHub />
      </Route>

      <Route path="/form/duct-leakage/:version/1/:appointmentId"> 
        <DuctLeakagePage1 />
      </Route>
      <Route path="/form/duct-leakage/:version/2/:appointmentId"> 
        <DuctLeakagePage2 />
      </Route>
      <Route path="/form/duct-leakage/:version/3/:appointmentId"> 
        <DuctLeakagePage3 />
      </Route>
      <Route path="/form/duct-leakage/:appointmentId"> 
        <DuctLeakageHub />
      </Route>

      <Route path="/form/compliance-report/:version/1/:appointmentId"> 
        <ComplianceReportPage1 />
      </Route>
      <Route path="/form/compliance-report/:version/2/:appointmentId"> 
        <ComplianceReportPage2 />
      </Route>
      <Route path="/form/compliance-report/:version/3/:appointmentId"> 
        <ComplianceReportPage3 />
      </Route>
      <Route path="/form/compliance-report/:appointmentId"> 
        <ComplianceReportHub />
      </Route>

      <Route path="/form/casinspection/:version/1/:appointmentId"> 
        <InspectionPage1 />
      </Route>
      <Route path="/form/casinspection/:version/2/:appointmentId"> 
        <InspectionPage2 />
      </Route>
      <Route path="/form/casinspection/:version/3/:appointmentId"> 
        <InspectionPage3 />
      </Route>
      <Route path="/form/casinspection/:version/4/:appointmentId"> 
        <InspectionPage4 />
      </Route>
      <Route path="/form/casinspection/:version/5/:appointmentId"> 
        <InspectionPage5 />
      </Route>
      <Route path="/form/casinspection/:version/6/:appointmentId"> 
        <InspectionPage6 />
      </Route>
      <Route path="/form/casinspection/:version/7/:appointmentId"> 
        <InspectionPage7 />
      </Route>
      <Route path="/form/casinspection/:version/8/:appointmentId"> 
        <InspectionPage8 />
      </Route>
      <Route path="/form/casinspection/:version/9/:appointmentId"> 
        <InspectionPage9 />
      </Route>
      <Route path="/form/casinspection/:version/10/:appointmentId"> 
        <InspectionPage10 />
      </Route>
      <Route path="/form/casinspection/:version/11/:appointmentId"> 
        <InspectionPage11 />
      </Route>
      <Route path="/form/casinspection/:appointmentId"> 
        <InspectionFormHub />
      </Route>

      <Route path="/form/repaired-and-replaced/:version/1/:appointmentId"> 
        <RepairedAndReplacedPage1 />
      </Route>
      <Route path="/form/repaired-and-replaced/:version/2/:appointmentId"> 
        <RepairedAndReplacedPage2 />
      </Route>
      <Route path="/form/repaired-and-replaced/:appointmentId"> 
        <RAndRHub />
      </Route>

      <Route path="/form/casinterim/:version/:appointmentId">
        <CASInterim />
      </Route>

      <Route path="/form/sce/:version/:appointmentId">
        <SCE />
      </Route>

      <Route path="/form/insulationCertificate/:version/:appointmentId">
        <InsulationCertifcate />
      </Route>

      <Route path="/form/noticeOfSurvey/:version/:appointmentId">
        <NoticeOfSurvey />
      </Route>

      <Route path="/form/windowAndDoor/:version/:appointmentId">
        <WindowAndDoor />
      </Route>

      <Route path="/form/wxwo/:version/:appointmentId">
        <WXWO />
      </Route>
      <Route path="/form/duct/:version/:appointmentId">
        <Duct />
      </Route>
      <Route path="/form/ngat/:version/:appointmentId">
        <NGAT />
      </Route>
      <Route path="/form/noc/:version/:appointmentId">
        <NOC />
      </Route>
      <Route path="/form/aiwo/:version/:appointmentId">
        <AIWO />
      </Route>
      <Route path="/form/washer/:version/:appointmentId">
        <Washer />
      </Route>
      {/* <Route path="/appointment/:appointmentId/state-forms">
        <StateForms />
      </Route> */}
      <Route path="/appointment/:appointmentId">
        <Appointment />
      </Route>
      <Route path='/scan/:appointmentId/:type/:version/:fieldName'>
        <ScanQr/>
      </Route>
      <Route path="/manage">
        <Manage />
      </Route>
      <Route path="/reassign/:appointmentId">
        <Reassign />
      </Route>
      <Route path="/swap">
        <Swap />
      </Route>
      <Route path="/app">
        <Dashboard />
      </Route>
      <Route path="/">
        <Login />
      </Route>
    </Switch>
  );
};

export default Routes;
